import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import MenuItem from 'app/shared/layout/menus/menu-item';
import React from 'react';
import { Translate } from 'react-jhipster';

interface IControlTower {
  isAdmin: boolean;
  isManufacturerAdmin: boolean;
  isTransporterAdmin: boolean;
  isRepresentativeAdmin: boolean;
  index: number;
  onExpand: (index: number) => void;
  isExpanded: boolean;
  setOpen: (value: boolean) => void;
  drawerIsOpen: boolean;
}

export const ControlTower = ({
  isAdmin,
  isManufacturerAdmin,
  isTransporterAdmin,
  isRepresentativeAdmin,
  onExpand,
  isExpanded,
  index,
  drawerIsOpen,
  setOpen,
}: IControlTower) => {
  const initialTheme = localStorage.getItem('USER_THEME') as 'light' | 'dark' | null;

  return (
    <>
      <Tooltip title={drawerIsOpen ? '' : <Translate contentKey="global.menu.controlTower">Control Tower</Translate>} placement="right">
        <ListItemButton
          id="indicators-button"
          onClick={() => onExpand(index)}
          sx={{
            pl: { xs: '18px', md: '32px' },
            backgroundImage: isExpanded
              ? initialTheme === 'dark'
                ? 'linear-gradient(rgba(6, 13, 31, 0.9), rgba(6, 13, 31, 0.9))'
                : 'linear-gradient(rgb(226,226,226), rgb(226,226,226))'
              : 'none',
          }}
        >
          <ListItemIcon>
            <AnalyticsIcon />
          </ListItemIcon>
          <ListItemText
            primary={<Translate contentKey="global.menu.controlTower">Control Tower</Translate>}
            primaryTypographyProps={{
              fontFamily: 'Public Sans',
              fontWeight: isExpanded ? '600' : '400',
              fontSize: '14px',
            }}
            sx={{ opacity: open ? 1 : 0 }}
          />
          {isExpanded ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
      </Tooltip>

      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        {(isAdmin || isManufacturerAdmin || isTransporterAdmin || isRepresentativeAdmin) && (
          <List component="div" disablePadding onClick={() => setOpen(false)}>
            <MenuItem icon="caret-right" to="/asset-classification/dashboard">
              <Translate contentKey="global.menu.controlTower" />
            </MenuItem>

            {!isRepresentativeAdmin && (
              <>
                <MenuItem icon="caret-right" to="/asset-classification/preset-company/">
                  <Translate contentKey="fleetSenseApp.presetCompany.home.title" />
                </MenuItem>
                <MenuItem icon="caret-right" to="/asset-classification/preset-vehicle/">
                  <Translate contentKey="fleetSenseApp.presetVehicle.home.title" />
                </MenuItem>
                <MenuItem icon="caret-right" to="/asset-classification/preset-weight/">
                  <Translate contentKey="fleetSenseApp.presetWeight.home.title" />
                </MenuItem>
              </>
            )}
          </List>
        )}
      </Collapse>
    </>
  );
};
